import Sortable from 'sortablejs'
export default class OrganizePage {
  constructor (list) {
    if(list) {
      this.list = list
      let url = '/admin/pages/setposition'
      const child = this.list.querySelector('.listPage_items_children ul')
      if (this.list.classList.contains('drag-posts')) {
        url = '/admin/posts/setposition'
      }
      if (list !== null) {
        Sortable.create(this.list, {
          group: { name: 'items', pull: false, put: false },
          draggable: '.listPage_items',
          store: {
            /**
             * Get the order of elements. Called once during initialization.
             * @param   {Sortable}  sortable
             * @returns {Array}
             */
            get: function (sortable) {
              const order = localStorage.getItem(sortable.options.group.name)
              return order ? order.split('|') : []
            },

            /**
             * Save the order of elements. Called onEnd (when the item is dropped).
             * @param {Sortable}  sortable
             */
            set: function (sortable) {
              const order = sortable.toArray()
              const result = Object.values(order)

              // ajax
              const httpRequest = new XMLHttpRequest()
              httpRequest.open('GET', url + '?results=' + JSON.stringify(result), true)
              httpRequest.send()
            }
          }

        })
      }
      if (child !== null) {
        Sortable.create(child, {
          group: { name: 'child', pull: false, put: false },
          draggable: '.listPage_items_children_items',
          store: {
            /**
             * Get the order of elements. Called once during initialization.
             * @param   {Sortable}  sortable
             * @returns {Array}
             */
            get: function (sortable) {
              const order = localStorage.getItem(sortable.options.group.name)
              return order ? order.split('|') : []
            },

            /**
             * Save the order of elements. Called onEnd (when the item is dropped).
             * @param {Sortable}  sortable
             */
            set: function (sortable) {
              const order = sortable.toArray()
              const result = Object.values(order)

              // ajax
              const httpRequest = new XMLHttpRequest()
              httpRequest.open('GET', url + '?results=' + JSON.stringify(result), true)
              httpRequest.send()
            }
          }

        })
      }
    }
  }
}
